import type {
    MembershipProfileAnswerWithQuestion,
    ProfileAnswer,
    QuestionKey,
} from '@fruitful/member-profile';

import {
    captureDebug,
    captureException,
    captureMessage,
    captureWarning,
} from '../../logger/Logger';

export const MemberProfileLogger = {
    captureMessage,
    captureWarning,
    captureException,
    captureDebug,
};

export const findMembershipProfileAnswerByQuestionKey = <
    TInput extends ProfileAnswer,
    TOutput extends ProfileAnswer,
>(
    answers: Array<MembershipProfileAnswerWithQuestion<TInput>>,
    questionKey: QuestionKey,
): MembershipProfileAnswerWithQuestion<TOutput> | undefined => {
    return answers.find(
        (answer) =>
            answer.membershipProfileQuestion.questionKey === questionKey,
    ) as MembershipProfileAnswerWithQuestion<TOutput> | undefined;
};
